/**
 * No lugar de um controle de escrita, na aba de depuração (spec 020): diz que
 * ele existe para o cliente e por que não está aqui. Quem garante o "só
 * leitura" é a API (403 impersonation_read_only); a tela só acompanha.
 */
import type { ReactNode } from 'react';
import { Eye } from 'lucide-react';
import { cn } from '@/lib/utils';

export function ReadOnlyNotice({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div
      className={cn(
        'flex items-start gap-2 rounded-md border border-[#FFE58F] bg-[#FFFBE6] px-3 py-2 text-sm text-[#874D00]',
        className
      )}
    >
      <Eye className="mt-0.5 size-4 shrink-0" aria-hidden />
      <span>{children}</span>
    </div>
  );
}
